var PhxCheckout = (function (PhxCheckout) {
  //Import modules only for jest.
  if (
    typeof process !== "undefined" &&
    process.env &&
    process.env.NODE_ENV === "test"
  ) {
    const util = require("./util");
    Object.assign(PhxCheckout, util);
  }
  PhxCheckout.messenger = (function messenger() {
    // Static mapping of action tokens to their handler functions.
    // Only actions listed here can be invoked via postMessage.
    var ALLOWED_ACTIONS = {
      "creditCardValidationHelper.validateCreditCard": true,
      "creditCardValidationHelper.validateCreditCardNumber": true,
      "creditCardValidationHelper.validateExpirationDate": true,
      "creditCardValidationHelper.validateExpirationMonth": true,
      "creditCardValidationHelper.validateSecurityCode": true,
      "creditCardValidationHelper.getCVVLengthForCreditCard": true,
      "creditCardValidationHelper.getValidMonths": true,
      "creditCardValidationHelper.getValidYears": true,
      "creditCardValidationHelper.hidePayPal": true,
      "creditCardValidationHelper.setAcceptedCardTypes": true,
      "creditCardValidationHelper.setValidateCreditCardNumber": true,
      "creditCardValidationHelper.obfuscateCreditCard": true,
      "creditCardValidationHelper.restoreCreditCardValue": true,
      "creditCardValidationHelper.hideObfuscated": true,
      "creditCardValidationHelper.validatePostalCode": true,
      "creditCardValidationHelper.validatePostalWithMessage": true,
      "creditCardValidationHelper.setPostalError": true,
      "creditCardValidationHelper.editPreFill": true,
      "creditCardValidationHelper.clearCardData": true,
      "checkoutHelper.submitSdeData": true,
      "checkoutHelper.submitSde3dsData": true,
      "checkoutHelper.submitForm": true,
      "checkoutHelper.setPaymentType": true,
      "checkoutHelper.getCreditCardInfo": true,
      "checkoutHelper.getCardType": true,
      "checkoutHelper.sendCardTypeToParent": true,
      "checkoutHelper.toggleCardTypeIcons": true,
      "checkoutHelper.showCardImage": true,
      "checkoutHelper.sendPaymentTypeToParent": true,
      "checkoutHelper.sendPaymentIdToParent": true,
      "checkoutHelper.setCVVMaxLength": true,
      "checkoutHelper.toggleCallout": true,
      "checkoutHelper.toggleCalloutExternal": true,
      "checkoutHelper.forceNumeric": true,
      "checkoutHelper.autoFill": true,
      "checkoutHelper.ping": true,
      "checkoutHelper.getPostalCode": true,
      "checkoutHelper.togglePostalCode": true,
      "checkoutHelper.sendPostalCode": true,
      "checkoutHelper.updateFrameSize": true,
      "checkoutHelper.loadTestDataConfig": true,
      "directDebitValidationHelper.validateIBAN": true,
      "directDebitValidationHelper.validateAccountHolder": true,
      "directDebitValidationHelper.validateDirectDebit": true,
    };

    function _parseOrigin(origin) {
      origin = origin.split(":")[1];
      origin = origin.replace(/^\/\//, "");
      return origin;
    }

    //TODO: split this code + isLocal() to common module to be shared with backend code.
    function _isLocal(host) {
      return host && host.indexOf("local") === 0;
    }

    function _isValidOrigin(refererUrl, host) {
      if (_isLocal(host)) return true;

      if (!refererUrl || refererUrl === "") return false;

      // Strict ancestry domain check — anchored regex with explicit allowed values only.
      // Allowed subdomains: www, local, petdnalocal, petdna, secure, purchase
      // Allowed environments: (none/prod), dev, stage
      // Allowed TLDs: com, co.uk, com.au, fr, it, de, se, ca, mx
      var isAncestryDomain =
        /^(?:(?:www|local|petdnalocal|petdna|secure|purchase)\.)?ancestry(?:dev|stage)?\.(?:com|co\.uk|com\.au|fr|it|de|se|ca|mx)(?::\d+)?(?:\/.*)?$/i.test(
          refererUrl,
        );

      // SalesForce domains (separate — temporary integration for SalesForce team)
      var isSalesForceDomain =
        /^ancestry(\.lightning\.|--.*(\..*\.visual\.|\.visual|\.lightning\.|\.vf\.|--.*\..*\.visual\.|--.*\.visual|--.*\.sandbox\.vf\.))force\.com(\/.*)?$/i.test(
          refererUrl,
        );

      // Zendesk support domains
      var isZendeskDomain =
        /^ancestrysupport\d*\.zendesk\.com(\/.*)?$/i.test(refererUrl);

      // Zendesk Apps Framework domains (apps.zdusercontent.com)
      var isZendeskAppsDomain =
        /^[^\/]+\.apps\.zdusercontent\.com(\/.*)?$/i.test(refererUrl);

      return isAncestryDomain || isSalesForceDomain || isZendeskDomain || isZendeskAppsDomain;
    }

    function _isSameOrigin(event) {
      var localWindow = PhxCheckout.util.getWindow();
      var srcOrigin = event.origin || event.originalEvent.origin;
      //IE 11 weird hack for origin
      var windowOrigin = !localWindow.location.origin
        ? localWindow.location.protocol +
          "//" +
          localWindow.location.hostname +
          (localWindow.location.port ? ":" + localWindow.location.port : "")
        : localWindow.location.origin;
      var srcBaseOrigin = _parseOrigin(srcOrigin);
      var ourBaseOrigin = _parseOrigin(windowOrigin);

      if (_isValidOrigin(srcBaseOrigin, ourBaseOrigin)) {
        return true;
      }

      if (console) {
        console.log("sameOriginCheck failed: ", srcBaseOrigin, ourBaseOrigin);
      }
      return false;
    }

    // Stores the validated parent origin for outbound postMessage calls
    // initiated by the iframe (not in response to a received message)
    var _validatedParentOrigin = null;

    function _isAllowedAction(actionName) {
      return (
        typeof actionName === "string" &&
        ALLOWED_ACTIONS.hasOwnProperty(actionName)
      );
    }

    // Resolves and invokes the action statically via switch-case.
    // No dynamic function path resolution — each action maps directly to a known method.
    function _executeAction(actionName, payload) {
      switch (actionName) {
        case "creditCardValidationHelper.validateCreditCard":
          return PhxCheckout.creditCardValidationHelper.validateCreditCard(payload);
        case "creditCardValidationHelper.validateCreditCardNumber":
          return PhxCheckout.creditCardValidationHelper.validateCreditCardNumber(payload);
        case "creditCardValidationHelper.validateExpirationDate":
          return PhxCheckout.creditCardValidationHelper.validateExpirationDate(payload);
        case "creditCardValidationHelper.validateExpirationMonth":
          return PhxCheckout.creditCardValidationHelper.validateExpirationMonth(payload);
        case "creditCardValidationHelper.validateSecurityCode":
          return PhxCheckout.creditCardValidationHelper.validateSecurityCode(payload);
        case "creditCardValidationHelper.getCVVLengthForCreditCard":
          return PhxCheckout.creditCardValidationHelper.getCVVLengthForCreditCard(payload);
        case "creditCardValidationHelper.getValidMonths":
          return PhxCheckout.creditCardValidationHelper.getValidMonths(payload);
        case "creditCardValidationHelper.getValidYears":
          return PhxCheckout.creditCardValidationHelper.getValidYears(payload);
        case "creditCardValidationHelper.hidePayPal":
          return PhxCheckout.creditCardValidationHelper.hidePayPal(payload);
        case "creditCardValidationHelper.setAcceptedCardTypes":
          return PhxCheckout.creditCardValidationHelper.setAcceptedCardTypes(payload);
        case "creditCardValidationHelper.setValidateCreditCardNumber":
          return PhxCheckout.creditCardValidationHelper.setValidateCreditCardNumber(payload);
        case "creditCardValidationHelper.obfuscateCreditCard":
          return PhxCheckout.creditCardValidationHelper.obfuscateCreditCard(payload);
        case "creditCardValidationHelper.restoreCreditCardValue":
          return PhxCheckout.creditCardValidationHelper.restoreCreditCardValue(payload);
        case "creditCardValidationHelper.hideObfuscated":
          return PhxCheckout.creditCardValidationHelper.hideObfuscated(payload);
        case "creditCardValidationHelper.validatePostalCode":
          return PhxCheckout.creditCardValidationHelper.validatePostalCode(payload);
        case "creditCardValidationHelper.validatePostalWithMessage":
          return PhxCheckout.creditCardValidationHelper.validatePostalWithMessage(payload);
        case "creditCardValidationHelper.setPostalError":
          return PhxCheckout.creditCardValidationHelper.setPostalError(payload);
        case "creditCardValidationHelper.editPreFill":
          return PhxCheckout.creditCardValidationHelper.editPreFill(payload);
        case "creditCardValidationHelper.clearCardData":
          return PhxCheckout.creditCardValidationHelper.clearCardData(payload);
        case "checkoutHelper.submitSdeData":
          return PhxCheckout.checkoutHelper.submitSdeData(payload);
        case "checkoutHelper.submitSde3dsData":
          return PhxCheckout.checkoutHelper.submitSde3dsData(payload);
        case "checkoutHelper.submitForm":
          return PhxCheckout.checkoutHelper.submitForm(payload);
        case "checkoutHelper.setPaymentType":
          return PhxCheckout.checkoutHelper.setPaymentType(payload);
        case "checkoutHelper.getCreditCardInfo":
          return PhxCheckout.checkoutHelper.getCreditCardInfo(payload);
        case "checkoutHelper.getCardType":
          return PhxCheckout.checkoutHelper.getCardType(payload);
        case "checkoutHelper.sendCardTypeToParent":
          return PhxCheckout.checkoutHelper.sendCardTypeToParent(payload);
        case "checkoutHelper.toggleCardTypeIcons":
          return PhxCheckout.checkoutHelper.toggleCardTypeIcons(payload);
        case "checkoutHelper.showCardImage":
          return PhxCheckout.checkoutHelper.showCardImage(payload);
        case "checkoutHelper.sendPaymentTypeToParent":
          return PhxCheckout.checkoutHelper.sendPaymentTypeToParent(payload);
        case "checkoutHelper.sendPaymentIdToParent":
          return PhxCheckout.checkoutHelper.sendPaymentIdToParent(payload);
        case "checkoutHelper.setCVVMaxLength":
          return PhxCheckout.checkoutHelper.setCVVMaxLength(payload);
        case "checkoutHelper.toggleCallout":
          return PhxCheckout.checkoutHelper.toggleCallout(payload);
        case "checkoutHelper.toggleCalloutExternal":
          return PhxCheckout.checkoutHelper.toggleCalloutExternal(payload);
        case "checkoutHelper.forceNumeric":
          return PhxCheckout.checkoutHelper.forceNumeric(payload);
        case "checkoutHelper.autoFill":
          return PhxCheckout.checkoutHelper.autoFill(payload);
        case "checkoutHelper.ping":
          return PhxCheckout.checkoutHelper.ping(payload);
        case "checkoutHelper.getPostalCode":
          return PhxCheckout.checkoutHelper.getPostalCode(payload);
        case "checkoutHelper.togglePostalCode":
          return PhxCheckout.checkoutHelper.togglePostalCode(payload);
        case "checkoutHelper.sendPostalCode":
          return PhxCheckout.checkoutHelper.sendPostalCode(payload);
        case "checkoutHelper.updateFrameSize":
          return PhxCheckout.checkoutHelper.updateFrameSize(payload);
        case "checkoutHelper.loadTestDataConfig":
          return PhxCheckout.checkoutHelper.loadTestDataConfig(payload);
        case "directDebitValidationHelper.validateIBAN":
          return PhxCheckout.directDebitValidationHelper.validateIBAN(payload);
        case "directDebitValidationHelper.validateAccountHolder":
          return PhxCheckout.directDebitValidationHelper.validateAccountHolder(payload);
        case "directDebitValidationHelper.validateDirectDebit":
          return PhxCheckout.directDebitValidationHelper.validateDirectDebit(payload);
        default:
          return undefined;
      }
    }

    function _messageHandler(event) {
      if (!_isSameOrigin(event)) {
        return;
      }

      var actionName = event.data && event.data.name;

      if (!_isAllowedAction(actionName)) {
        if (console && typeof actionName === "string") {
          console.log(
            "postMessage action blocked (not in allowlist): ",
            actionName,
          );
        }
        return;
      }

      // Store validated origin for outbound messages initiated by the iframe
      _validatedParentOrigin = event.origin || event.originalEvent.origin;

      var response, error;
      try {
        var result = _executeAction(actionName, event.data.payload);
        // Only assign cloneable values — Promises cannot be sent via postMessage
        if (result && typeof result.then === "function") {
          response = undefined;
        } else {
          response = result;
        }
      } catch (e) {
        error = e.message;
      }

      _postMessageToParent(
        {
          id: event.data.id,
          response: response,
          error: error,
          action: "FRAMEMESSENGEREVENT",
        },
        _validatedParentOrigin,
      );
    }

    function _postMessageToParent(data, targetOrigin) {
      var localWindow = PhxCheckout.util.getWindow();
      localWindow.parent.postMessage(
        data,
        targetOrigin || _validatedParentOrigin || localWindow.location.origin,
      );
    }

    return {
      isLocal: _isLocal,
      isValidOrigin: _isValidOrigin,
      isSameOrigin: _isSameOrigin,
      isAllowedAction: _isAllowedAction,
      messageHandler: _messageHandler,
      postMessageToParent: _postMessageToParent,
    };
  })();

  return PhxCheckout;
})(PhxCheckout || {});

if (window.addEventListener) {
  window.addEventListener(
    "message",
    PhxCheckout.messenger.messageHandler,
    false,
  );
} else if (window.attachEvent) {
  window.attachEvent("message", PhxCheckout.messenger.messageHandler);
}

if (
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV === "test"
) {
  module.exports = PhxCheckout; //export it as module only for jest.
}
